export const mutations = {
  SET_SURVEY_ACCOUNT_ID(state, payload) {
    state.surveyAccountId = payload
  },
  SET_SURVEY_TOKEN(state, payload) {
    state.surveyToken = payload
  },
  SET_SURVEY_SELECTED_UNIT(state, payload) {
    state.surveySelectedUnit = payload
  },
  SET_SURVEY_PUBLIC_DETAILS(state, payload) {
    state.surveyPublicDetails = payload
  },
  SET_SURVEY_USER_ID(state, payload) {
    state.surveyUserId = payload
  },
  SET_SURVEY_FAVORITE_UNIT_ID(state, payload) {
    state.surveyFavoriteUnitId = payload
  }
}
